export enum CommentTypes {
  WELCOME_MSG = 'WELCOME_MSG',
  NEW_USERS = 'NEW_USERS'
}
